import { getApplicationSourceDisplay } from "@/helpers/application-source.helper"
import { BaseImage, SourceControlIcon, VmIcons } from "@/icons"

import type { IconResourceComponent } from "."
import { ImageIcon } from "../../icons/Images"

export const IconResource: IconResourceComponent = (props) => {
  const { type, sourceControl, imageSource, subjectType } = props
  if (!type) return null
  const applicationSourceDisplay = getApplicationSourceDisplay(props)
  if (applicationSourceDisplay) return <applicationSourceDisplay.Icon />
  if (type === "ImageRepository" && imageSource)
    return <ImageIcon imageSource={imageSource} />
  if (type === "Image") return <BaseImage />
  if (type === "Vm") return <VmIcons type={subjectType} />
  if (!sourceControl) return null
  return <SourceControlIcon sourceControl={sourceControl} />
}
